/**
 * Как подписывается сданная домашка — одно правило на все экраны.
 *
 * До 10.09.2026 цепочка `lesson_title || section_title || …` была выписана в трёх местах
 * врозь, и мобильная строка про неё просто не знала: заголовок был прибит гвоздём
 * («Homework»), дата — без локали («09.09.2026»). Заказчик увидел это на телефоне.
 * Правило вынесено сюда, чтобы расходиться было нечему.
 */

/** Ровно то, что нужно для подписи: остальные поля работы здесь не при чём. */
export type HomeworkTitleSource = {
  lesson_title?: string;
  section_title?: string;
};

export type HomeworkTitleLines = {
  /** Крупная строка: урок, а если урока нет — раздел, а если нет и его — запасное слово. */
  title: string;
  /** Мелкая строка перед состоянием и датой. `null`, когда добавить нечего. */
  section: string | null;
};

/**
 * @param hw       работа (нужны только два названия, их отдаёт сервер)
 * @param fallback запасное слово, когда раздел удалён и названий нет вовсе
 *
 * ⚠️ Раздел НЕ повторяет заголовок. У пяти уроков курса «Positive Thinking» и соседних
 * название раздела совпадает с названием урока слово в слово — без этой отсечки ученик
 * видел бы одну и ту же строку дважды подряд.
 */
export function homeworkTitleLines(
  hw: HomeworkTitleSource,
  fallback: string,
): HomeworkTitleLines {
  const lesson = (hw.lesson_title ?? '').trim();
  const section = (hw.section_title ?? '').trim();

  const title = lesson || section || fallback;
  return {
    title,
    section: section && section !== title ? section : null,
  };
}
